/**
 * 动态设置favicon
 * @param {string} iconUrl - 图标URL
 */
export function setFavicon(iconUrl) {
  // 查找现有的favicon元素
  let link = document.querySelector("link[rel*='icon']");

  if (!link) {
    // 如果不存在favicon元素，则创建一个
    link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/x-icon";
    document.head.appendChild(link);
  }

  // 设置favicon的URL
  link.href = iconUrl;
}

/**
 * 重置favicon为默认图标
 * @param {string} defaultIconUrl - 默认图标URL
 */
export function resetFavicon(defaultIconUrl) {
  setFavicon(defaultIconUrl);
}



// WEBPACK FOOTER //
// ./src/utils/favicon.js